// extracted by mini-css-extract-plugin
export default {"formContainer":"Styles_formContainer__VNci2","pageTitle":"Styles_pageTitle__q9SAn","error":"Styles_error__0JRW8","darkTheme":"Styles_darkTheme__Xip+L"};